import { GetAgencyType, EditAgencyType,InsertAgencyType, DELETEAgencyType } from "../type";
const initialState = {
  getAgencyType: [],
  InsertAgencyType: [],
  UpdateAgencyType: [],
  DeleteAgencyType: [],

  loading: true,
};
const AgencyTypeR = (state = initialState, action) => {
  switch (action.type) {
    case GetAgencyType:
      return {
        ...state,
        getAgencyType: action.payload,
        loading: false,
      };
    case InsertAgencyType:
      return {
        getAgencyType: state.getAgencyType,
        InsertAgencyType: action.payload,
        loading: false,
      };
      case EditAgencyType:
        return {
          getAgencyType: state.getAgencyType,
          UpdateAgencyType: action.payload,
          loading: false,
        };
        case DELETEAgencyType:
          return {
            getAgencyType: state.getAgencyType,
            DeleteAgencyType: action.payload,
            loading: false,
          };
    default:
      return state;
  }
};
export default AgencyTypeR;
